import { createContext } from 'react'
import { LayoutType } from '../typings/LayoutType'

export const IsInLayoutContext = createContext<LayoutType | undefined>(
  undefined
)
